import { RATCHETING } from '../Config';

export const DB_NAME = "EncryptedChatDB";
export const DB_VERSION = 3;

/*
{
  userKeyHash: "u123...",         // Derived from login credentials
  encConversationId: "abc...",    // Encrypted+salted conversation ID
  salt: "random_salt_base64",     // Used in encConversationId + encryption
  encryptedContent: "...",        // Fully encrypted payload
  timestamp: 12345678             // Encrypted or padded if needed
}
*/

export function setupSchema(db) {

  console.log("[setupSchema] Existing stores:", db.objectStoreNames);

  // messages
  if (!db.objectStoreNames.contains("messages")) {
    const store = db.createObjectStore("messages", { 
      keyPath: "id", 
      autoIncrement: true 
    });
    store.createIndex("userKeyHash", "userKeyHash");
  }

  // conversations meta
  if (!db.objectStoreNames.contains("conversations")) {
    const store = db.createObjectStore("conversations", { 
      keyPath: "conversationId" 
    });

    store.createIndex("userKeyHash", "userKeyHash");
  }

  // ratcheting keys
  if (!db.objectStoreNames.contains(RATCHETING.STORE_NAME)) {
    const store = db.createObjectStore(RATCHETING.STORE_NAME, { 
      keyPath: RATCHETING.STORE_KEY_PATH, 
    });

    store.createIndex('byCompoundKey', 'compoundKey');
    store.createIndex('byUserKeyHash', 'userKeyHash');
    store.createIndex('byHashedConversationId', 'hashedConversationId');
    store.createIndex('byContactKey', 'contactKeyB58');
  }

  // contact public keys
  if (!db.objectStoreNames.contains("contactPublicKeys")) {
    const store = db.createObjectStore("contactPublicKeys", {
      keyPath: "hashedViewKey",
    });
  }
}